module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_bluepotion_m.d5e8401cdf52880d1cce9b1dbcea5109.png";